// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { startOrderConnection } from "./Utills/orderSignalRService";
// import { addNotification } from "./redux/notifications/notificationSlice";
// import { toast, ToastContainer } from "react-toastify";
// import { logout } from './redux/action';
// import "react-toastify/dist/ReactToastify.css";
// import Routing from "./component/Routing/index";
// import { enableMapSet } from "immer";
// import "./App.css";

// enableMapSet();

// function App() {
//   const dispatch = useDispatch();
//   const restaurantId = "FA6886A5-8CAA-4EDB-95BB-5E6EE8D95349";
//   //  const [showPopup, setShowPopup] = useState(false);
//   const showPopup = useSelector((state) => state.session.showPopup);
//   const playSound = () => {
//     const sound = new Audio("/sounds/ringbell.mp3");
//     sound.play().catch(err => console.log("Audio blocked:", err));
//   };

//   // 🔔 SignalR Order Notification
//   useEffect(() => {
//     if (!restaurantId) return;

//     startOrderConnection(restaurantId, (data) => {

//       playSound();

//       if (data.type === "NEW_ORDER") {
//         toast.success(`🧾 New order from Table ${data.tableNumber}`, {
//           toastId: data.notificationId
//         });
//       }

//       if (data.type === "WAITER_REQUEST") {
//         toast.info(`🛎️ Table ${data.tableNumber} requested waiter`, {
//           toastId: data.notificationId
//         });
//       }

//       if (data.type === "PAYMENT_DONE") {
//         toast.success(`🧾 Payment completed for Table ${data.tableNumber}`, {
//           toastId: data.notificationId
//         });
//       }


//       // Save in Redux
//       dispatch(addNotification(data));
//     });
//   }, [restaurantId, dispatch]);

//   // ⏰ JWT Expiry Check

//   const handleLogout = () => {
//     try {
//       dispatch(logout());
//     } catch (error) {
//       console.error("Logot failed:", error.message);
//     }
//   };

//   return (
//     <div className="App">
//       <Routing />

//       {/* Toast */}
//       <ToastContainer position="top-right" autoClose={3000} theme="colored" />

//       {/* 🔊 Notification Sound */}
//       <audio
//         id="notifySound"
//         src="/sounds/ringbell.mp3"
//         preload="auto"
//       />

//       {/* ⏰ Session Timeout Popup */}
//       {showPopup && (
//         <div className="modal">
//           <div className="modal-content">
//             <h2>Session Expired</h2>
//             <p>Your session has timed out. Please log in again.</p>
//             <button className="logout" onClick={handleLogout}>Logout</button>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// }

// export default App;


import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { startOrderConnection } from "./Utills/orderSignalRService";
import { useNotificationAudio } from "./Utills/useNotificationAudio";
import { addNotification, syncRealtime } from "./redux/notifications/notificationSlice";
import { fetchTablesWitOtp, logout } from "./redux/action";
import { ToastContainer } from "react-toastify";
import { toast } from "./Utills/toast";
import "react-toastify/dist/ReactToastify.css";
import Routing from "./component/Routing/index";
import { enableMapSet } from "immer";
import "./App.css";
import { useTranslation } from "react-i18next";
import OfflineSyncStatus from "./component/OfflineSyncStatus";
import { getDeviceSettings, heartbeatTerminal } from "./pages/Setting/deviceSettingsApi";
import CounterLock from "./component/CounterLock/CounterLock";
import { ActionDialogProvider } from "./component/common/ActionDialog/ActionDialog";
import {
  normalizeTerminalSoundSettings,
  readTerminalSoundPreference,
  shouldPlayNotificationSound,
  TERMINAL_SOUND_CHANGED_EVENT,
  TERMINAL_SOUND_TEST_EVENT,
  terminalSoundStorageKey,
  writeTerminalSoundPreference,
} from "./Utills/terminalSoundPreference";

enableMapSet();

function App() {
  const { t } = useTranslation();
  const message = useCallback((key, values = {}) => Object.entries(values).reduce(
    (text, [name, value]) => text.replaceAll(`{{${name}}}`, String(value ?? "")),
    t(key, values)
  ), [t]);
  const dispatch = useDispatch();
  const showPopup = useSelector(state => state.session.showPopup);
  const isLoggingOut = useSelector(state => state.user.loggingOut);
  useSelector(state => state.user); // Re-read stored identity after login/logout actions.
  useLocation(); // Navigation can follow a stored-session change.
  const [, storageChanged] = useState(0);
  useEffect(() => {
    const sync = event => {
      if (!event.key || event.key === "admin_token_info") storageChanged(n => n + 1);
    };
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);
  let adminInfo;
  try { adminInfo = JSON.parse(localStorage.getItem("admin_token_info") || "{}"); }
  catch { adminInfo = {}; }
  const restaurantId = adminInfo?.restaurantId;
  const [soundSettings, setSoundSettings] = useState(() =>
    readTerminalSoundPreference(restaurantId));
  const soundSettingsRef = useRef(soundSettings);
  useEffect(() => { soundSettingsRef.current = soundSettings; }, [soundSettings]);
  useEffect(() => {
    if (!restaurantId) return undefined;
    heartbeatTerminal().catch(() => {});
    const timer = window.setInterval(() => heartbeatTerminal().catch(() => {}), 5 * 60 * 1000);
    return () => window.clearInterval(timer);
  }, [restaurantId]);
  const audioRef = useRef(null);
  const hasEnabledSounds = soundSettings.enabled && (soundSettings.newOrderEnabled ||
    soundSettings.waiterRequestEnabled || soundSettings.paymentEnabled);
  const { status: audioStatus, play: playNotificationSound, preview: previewNotificationSound, unlock: unlockAudioContext } =
    useNotificationAudio(audioRef, Boolean(restaurantId) && hasEnabledSounds);

  useEffect(() => {
    if (!restaurantId) {
      setSoundSettings(readTerminalSoundPreference(null));
      return undefined;
    }
    let active = true;
    setSoundSettings(readTerminalSoundPreference(restaurantId));
    getDeviceSettings().then(result => {
      if (!active) return;
      const settings = writeTerminalSoundPreference(restaurantId, result?.terminal || {});
      setSoundSettings(settings);
    }).catch(() => {});

    const normalizedRestaurantId = String(restaurantId).toLowerCase();
    const onPreferenceChanged = event => {
      if (event.detail?.restaurantId === normalizedRestaurantId) {
        setSoundSettings(normalizeTerminalSoundSettings(event.detail.settings ?? { enabled: event.detail.enabled }));
      }
    };
    const onStorage = event => {
      if (event.key === terminalSoundStorageKey(restaurantId)) {
        setSoundSettings(readTerminalSoundPreference(restaurantId));
      }
    };
    window.addEventListener(TERMINAL_SOUND_CHANGED_EVENT, onPreferenceChanged);
    window.addEventListener("storage", onStorage);
    return () => {
      active = false;
      window.removeEventListener(TERMINAL_SOUND_CHANGED_EVENT, onPreferenceChanged);
      window.removeEventListener("storage", onStorage);
    };
  }, [restaurantId]);

  useEffect(() => {
    const testSound = event => {
      previewNotificationSound().then(result => event.detail?.onResult?.(result));
    };
    window.addEventListener(TERMINAL_SOUND_TEST_EVENT, testSound);
    return () => window.removeEventListener(TERMINAL_SOUND_TEST_EVENT, testSound);
  }, [previewNotificationSound]);

  useEffect(() => {
    if (!restaurantId) return;
    return startOrderConnection(restaurantId, data => {
      if (shouldPlayNotificationSound(soundSettingsRef.current, data.type)) playNotificationSound();
      if (data.type === "TAKEAWAY_NEW_ORDER") {
        toast.success(message("New takeaway order {{token}}", { token: data.tokenNumber }), { toastId: data.notificationId });
      } else if (data.type === "TAKEAWAY_PAYMENT_DONE") {
        toast.success(message("Payment received for {{token}}", { token: data.tokenNumber }), { toastId: data.notificationId });
      } else if (data.type === "NEW_ORDER") {
        toast.success(message("New order from Table {{table}}", { table: data.tableNumber }), { toastId: data.notificationId });
        dispatch(fetchTablesWitOtp());
      } else if (data.type === "WAITER_REQUEST") {
        toast.info(message("Table {{table}} requested waiter", { table: data.tableNumber }), { toastId: data.notificationId });
      } else if (data.type === "PAYMENT_DONE") {
        toast.success(message("Payment completed for Table {{table}}", { table: data.tableNumber }), { toastId: data.notificationId });
        dispatch(fetchTablesWitOtp());
      }
      dispatch(addNotification(data));
    }, undefined, () => dispatch(syncRealtime()));
  }, [restaurantId, dispatch, playNotificationSound, message]);

  const handleLogout = () => {
    try { dispatch(logout()); }
    catch (error) { console.error("Logout failed:", error.message); }
  };

  return (
    <ActionDialogProvider><div className="App">
      {isLoggingOut && (
        <div className="logout-transition" role="status" aria-live="polite" aria-label="Signing out">
          <div className="logout-transition__mark" aria-hidden="true">MZ</div>
          <div className="logout-transition__spinner" aria-hidden="true" />
          <p>Signing out…</p>
        </div>
      )}
      {restaurantId && hasEnabledSounds && audioStatus !== "ready" && (
        <button type="button" className="audio-alert-banner" onClick={unlockAudioContext}>
          {audioStatus === "error"
            ? "Sound unavailable. Check this device's audio and tap to retry."
            : "Enable sound alerts on this screen"}
        </button>
      )}
      <Routing />
      <CounterLock restaurantId={restaurantId} />
      <OfflineSyncStatus />
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
      <audio ref={audioRef} id="notifySound" src="/sounds/ringbell.mp3" preload="auto" />
      {showPopup && (
        <div className="modal">
          <div className="modal-content">
            <h2>Session Expired</h2>
            <p>Your session has timed out. Please log in again.</p>
            <button className="logout" onClick={handleLogout}>Logout</button>
          </div>
        </div>
      )}
    </div></ActionDialogProvider>
  );
}

export default App;
